import React from 'react';
import { useState, useRef } from 'react';
import { Box, Button, FormControl, InputLabel, TextField, Typography } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import logo from '../../assets/Project_Images/App_logo.png';
import { Link } from 'react-router-dom';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { ApiSendOtp, ApiVerifyOtp } from '../../apiService/Core/Apicall';
import { useDispatch, useSelector } from 'react-redux';
import { Images } from '../../global/GloblImages';
import storage from '../../utils/storage';




type OtpValues = {
    otp0: string;
    otp1: string;
    otp2: string;
    otp3: string;
    otp4: string;
    otp5: string;
};
const Otp: React.FC = () => {
    const dispatch = useDispatch()
    const location = useLocation()
    const inputRef = useRef<any>([]);
    const [showerror, setshowerror] = useState<boolean>(false);
    const navigation = useNavigate()
    const { MMLogo } = Images()


    const [otp, setOtp] = useState(Array(6).fill(""));

    // Formik Setup
    const formik = useFormik<OtpValues>({
        initialValues: {
            otp0: '',
            otp1: '',
            otp2: '',
            otp3: '',
            otp4: '',
            otp5: '',
        },
        validationSchema: Yup.object({
            otp0: Yup.string().matches(/^[0-9]$/, "Must be a single digit").required("Required"),
            otp1: Yup.string().matches(/^[0-9]$/, "Must be a single digit").required("Required"),
            otp2: Yup.string().matches(/^[0-9]$/, "Must be a single digit").required("Required"),
            otp3: Yup.string().matches(/^[0-9]$/, "Must be a single digit").required("Required"),
            otp4: Yup.string().matches(/^[0-9]$/, "Must be a single digit").required("Required"),
            otp5: Yup.string().matches(/^[0-9]$/, "Must be a single digit").required("Required"),
        }),
        validateOnChange: true,
        validateOnBlur: false,
        onSubmit: async (values) => {
            const userData = JSON.parse(storage.getItem('userData') || '{}');
            const Apidata = {
                emailId: storage.getItem('emailId'),
                requestType: "forgot_password",
                otp: Number(`${Object.values(values).join('')}`)

            }
            try {
                const response: any = await ApiVerifyOtp(Apidata);
                if (response.status) {
                    storage.setItem('auth', "setpassword");
                    navigation('/setpassword')
                }
            }
            catch (error) {
                alert(error)
                navigation('/otp')
            }
        }
    });

    const handleChange = (index: number, event: React.ChangeEvent<HTMLInputElement>) => {
        let value = event.target.value;
        if (!/^[0-9]?$/.test(value)) return; // Allow only numbers

        const newOtp = [...otp];
        newOtp[index] = value;
        setOtp(newOtp);

        // Move to next input field if a number is entered
        if (value && index < 5) {
            inputRef.current[index + 1].focus();
        }
        formik.setFieldValue(`otp${index}`, value);
    };

    const clearInput = (index: number, event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === 'Backspace') {
            const newOtp = [...otp];
            newOtp[index] = '';
            setOtp(newOtp);
            formik.setFieldValue(`otp${index}`, '');

            if (index > 0) {
                inputRef.current[index - 1].focus();
            }
        }
    };
    const resendotp = async () => {
        const Apidata = {
            emailId: storage.getItem('emailId'),
            requestType: "forgot_password"
        }
        const response = await ApiSendOtp(Apidata)
        alert(response.message)
    }
    return (
        <Box className='d-flex flex-column  align-items-center'>
            <Box component='img' className='mb-2' width='50%' zIndex={2} src={MMLogo} height='auto' alt='logo' />           
             <Box className='flex-grow-1 mt-5' position='relative'>
                <Typography className='text-main fs-3 fw-bold'>OTP</Typography>
                <Typography className='fs-18 '>Enter the OTP sent to your Email to complete E-Mail verification.</Typography>
                <Box className='input-border'>
                    <form onSubmit={formik.handleSubmit}>
                        <FormControl className='col-12 mt-5'>
                            <label className='label'>
                                <span>OTP{" "}
                                    <sup>
                                        <i className="fa-solid fa-star-of-life star"></i>
                                    </sup>
                                </span>
                            </label>
                            <Box display="flex" gap={1} justifyContent="center">
                                {otp.map((digit, index) => {
                                    const key = `otp${index}` as keyof typeof formik.values;
                                    return (

                                        <Box key={index} display="flex" flexDirection="column" alignItems="center">
                                            <TextField
                                                id={`otp-${index}`}
                                                value={formik.values[key]}
                                                onChange={(e: any) => handleChange(index, e)}
                                                onKeyDown={(e: any) => clearInput(index, e)}
                                                inputRef={(el) => (inputRef.current[index] = el)}
                                                variant="outlined"
                                                className='otp custom-textfield'
                                                inputProps={{
                                                    maxLength: 1,
                                                    style: { textAlign: 'center', fontSize: '1.5rem', padding: '14px' }
                                                }}
                                                sx={{"& fieldset":{border:"1px solid black !important"}}}

                                            />
                                            {showerror && formik.errors[key] ? (
                                                <Typography className="error text-danger" variant='caption'>
                                                    {formik.errors[key]}
                                                </Typography>
                                            ) : null}

                                        </Box>
                                    )
                                })}
                            </Box>
                        </FormControl>
                        <Link to='' className='text-main text-end d-block mt-2' onClick={resendotp}>Resend OTP?</Link>

                        <Button type="submit" onClick={() => setshowerror(true)} fullWidth className='button-primary py-2 mt-4'>Submit</Button>
                    </form>

                </Box>
            </Box>
        </Box>
    );
};

export default Otp;